import { Plugin } from "vue";

export const wtcUIPlugin: Plugin = {
    install(app) {
        // Add global stuff to register e.g. directives n stuff
    }
};
